import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { useChatbotContext as j } from "../../hooks/useChatbotContext.js";
import { UserMessage as D } from "./UserMessage.js";
import { BotMessageLayout as B } from "./BotMessageLayout.js";
import { BotMessageContainer as y } from "./BotMessageContainer.js";
import { BotMessageHeader as E } from "./BotMessageHeader.js";
import { BotMessage as m } from "./BotMessage.js";
import { BotMessageMarkdown as k } from "./BotMessageMarkdown.js";
import { BotDisclosure as b } from "./BotDisclosure.js";
import { BotFeedback as F } from "./BotFeedback.js";
import { BotMessageActions as H } from "./BotMessageActions.js";
import { BotThinkingHeader as N } from "./BotThinkingHeader.js";
import { BotThinkingDots as d } from "./BotThinkingDots.js";
import { highlightText as v } from "../../utils/highlightText.js";
import { Messages as P } from "./Messages.js";
import { ErrorMessage as R } from "./ErrorMessage.js";
import { useMemo as U } from "react";
function ot() {
  const { chatError: w, chatStatus: u, isBuilder: A, messages: i, isReadonly: s, search: l } = j(), C = U(() => {
    const t = i.filter((o) => o.role === "assistant").at(-1);
    return !t || !("parts" in t) || !Array.isArray(t.parts) ? !1 : t.parts.some((o) => o.type === "tool-invocation") || t.content !== "";
  }, [i]), S = u === "submitted" || u === "streaming" && !C, g = (t) => i.length <= 1 && t === 0 && !s;
  function a(t) {
    return t.replace(/<iframe([^>]*)>/gi, (o, c) => c.includes("sandbox=") ? o : `<iframe${c} sandbox="allow-forms">`);
  }
  return /* @__PURE__ */ e(P, { children: [
    i.map((t, o, c) => {
      const f = "parts" in t && Array.isArray(t.parts) ? t.parts : [], T = t.role === "assistant" && o === c.length - 1;
      return t.role === "user" ? /* @__PURE__ */ r(D, { children: t.content }, t.id) : t.content !== "" || f.length > 0 ? /* @__PURE__ */ r(B, { children: /* @__PURE__ */ e(y, { children: [
        /* @__PURE__ */ r(
          E,
          {
            index: o,
            message: t,
            showFeedback: o > 0 && !A && !s
          }
        ),
        /* @__PURE__ */ r("div", { className: "flex flex-col gap-y-2", children: f.length ? f.map((n, h, L) => {
          const x = h === L.length - 1, M = T && x && u === "streaming";
          if (n.type !== "tool-invocation" && n.type !== "text")
            return null;
          if (M && n.type === "tool-invocation")
            return /* @__PURE__ */ r(m, { children: /* @__PURE__ */ r(d, {}) }, h);
          if (n.type === "tool-invocation")
            return null;
          const { text: p = "" } = n;
          return /* @__PURE__ */ e(m, { className: "relative", children: [
            /* @__PURE__ */ r(
              k,
              {
                simulateStream: g(o),
                children: l ? v(a(p), l) : a(p)
              }
            ),
            M && !p && /* @__PURE__ */ r(d, {}),
            o === 0 ? /* @__PURE__ */ r(b, {}) : null
          ] }, h);
        }) : /* @__PURE__ */ e(m, { children: [
          /* @__PURE__ */ r(
            k,
            {
              simulateStream: g(o),
              children: l ? v(a(t.content), l) : a(t.content)
            }
          ),
          o === 0 ? /* @__PURE__ */ r(b, {}) : null
        ] }) }),
        s ? /* @__PURE__ */ r(F, { message: t }) : null,
        o > 0 && !s ? /* @__PURE__ */ r(H, { message: t }) : null
      ] }) }, t.id) : null;
    }),
    w ? /* @__PURE__ */ r(R, { unwrapped: !0 }) : null,
    S && /* @__PURE__ */ r(B, { children: /* @__PURE__ */ e(y, { children: [
      /* @__PURE__ */ r(N, {}),
      /* @__PURE__ */ r(m, { children: /* @__PURE__ */ r(d, {}) })
    ] }) })
  ] });
}
export {
  ot as MessagesList
};
